import { render, staticRenderFns } from "./TheFounder.vue?vue&type=template&id=7dc5e50e&scoped=true"
import script from "./TheFounder.vue?vue&type=script&lang=ts"
export * from "./TheFounder.vue?vue&type=script&lang=ts"
import style0 from "./TheFounder.vue?vue&type=style&index=0&id=7dc5e50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc5e50e",
  null
  
)

export default component.exports